import React, { useReducer } from 'react';

import { firestoreInitialize } from 'config/firebase/client';

import LocalitiesContext from './LocalitiesContext';
import LocalitiesReducer from './LocalitiesReducer';

const LocalitiesState = (props) => {
    const initialState = {
        getLocalities: {
            localities: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
    }

    const [state, dispatch] = useReducer(LocalitiesReducer, initialState);

    const getLocalities = () => {
        dispatch({ type: 'GET_LOCALITIES_LOADING' });

        let db = firestoreInitialize();

        db.collection('Localidades')
        .get()
        .then((documentSnapshots) => {
            dispatch({ type: 'GET_LOCALITIES', payload: { data: documentSnapshots.docs.map(doc => doc.data()) } })
        })
        .catch((error) => dispatch({ type: 'GET_LOCALITIES_ERROR', payload: { code: 'localities/error', message: error } }))
    };

    const getLocalitiesWhereId = async (ids) => {
        dispatch({ type: 'GET_LOCALITIES_LOADING' });

        let db = firestoreInitialize();

        if (typeof ids !== 'string') {
            if (ids.length > 0) {
                
            } else {
                dispatch({ type: 'GET_LOCALITIES_ERROR', payload: { code: 'localities/error', message: '' } })
            }
        } else {
            db.collection('Localidades')
            .where('localidadId', '==', ids)
            .get()
            .then((documentSnapshots) => {
                if (documentSnapshots.docs.map(doc => doc.data()).length > 0) {
                    let data;
                    documentSnapshots.forEach((document) => {
                        document.ref.collection("Servicios")
                            .get().then((querySnapshot) => {
                                if (data) {
                                    data = data.concat(querySnapshot.docs.map(doc => doc.data()))
                                } else {
                                    data = querySnapshot.docs.map(doc => doc.data())
                                }
                                dispatch({ type: 'GET_LOCALITIES', payload: { data: data } })
                        });
                    });
                } else {
                    dispatch({ type: 'GET_LOCALITIES_ERROR', payload: { code: 'localities/error', message: '' } })
                }
            })
        }
    };

    const getLocalitiesByAlly = (id) => {
        dispatch({ type: 'GET_LOCALITIES_LOADING' });

        let db = firestoreInitialize();

        db.collection('Localidades')
            .where('aliadoId', '==', id)
            .get()
            .then((documentSnapshots) => {
                dispatch({ type: 'GET_LOCALITIES', payload: { data: documentSnapshots.docs.map(doc => doc.data()) } })
            }).catch((error) => dispatch({ type: 'GET_LOCALITIES', payload: { code: 'localities/error', message: error } }))
    };

    const getLocalitiesServicesByAlly = (ally) => {
        dispatch({ type: 'GET_LOCALITIES_LOADING' });

        let db = firestoreInitialize();

        db.collection('Localidades')
            .where("aliadoId", "==", ally)
            .get()
            .then((documentSnapshots) => {
                if (documentSnapshots.docs.map(doc => doc.data()).length > 0) {
                    let data;
                    documentSnapshots.forEach((document) => {
                        document.ref.collection("Servicios")
                            .get().then((querySnapshot) => {
                                if (data) {
                                    data = data.concat(querySnapshot.docs.map(doc => doc.data()))
                                } else {
                                    data = querySnapshot.docs.map(doc => doc.data())
                                }
                                dispatch({ type: 'GET_LOCALITIES', payload: { data: data } })
                        });
                    });
                } else {
                    dispatch({ type: 'GET_LOCALITIES_ERROR', payload: { code: 'localities/error', message: '' } })
                }
            }).catch((error) => dispatch({ type: 'GET_LOCALITIES_ERROR', payload: { code: 'localities/error', message: error } }))
    };

    return (
        <LocalitiesContext.Provider value={{
            localitiesState: state.getLocalities,
            getLocalities,
            getLocalitiesWhereId,
            getLocalitiesByAlly,
            getLocalitiesServicesByAlly
        }}>
            {props.children}
        </LocalitiesContext.Provider>
    )
}

export default LocalitiesState;
